import {
  EfsMelcoEfsModelsMapping,
  EfsMelcoEfsModelsMappingOutput,
  EfsMelcoEfsModelsMappingOutputAttribute,
} from "melco-shared-logic";
import {
  DataMappingAttribute,
  DataMappingFormValueType,
} from "../components/inputFormats/AddOrEditDataMapping";

export const toAPIOutputAttribute = (
  configType: string,
  dataMappingAttribute: DataMappingAttribute | undefined
) => {
  if (!dataMappingAttribute) {
    return;
  }

  const { dataSource, colorCollection, fontCollection, sourceModifier, value } =
    dataMappingAttribute;

  const isColorCollectionSet = colorCollection && colorCollection !== "";
  const isFontCollectionSet = fontCollection && fontCollection !== "";
  const isSourceModifierSet =
    sourceModifier && sourceModifier !== "" && sourceModifier != "0";

  let configValue = "";
  let configOption = "UseValue";

  if (isColorCollectionSet || isFontCollectionSet) {
    configOption = "CollectionMapping";
  }

  if (isColorCollectionSet) {
    configValue = colorCollection!;
  } else if (isFontCollectionSet) {
    configValue = fontCollection!;
  }

  return {
    type: configType,
    format_detail_id: Number(dataSource),
    display_name: dataSource,
    value,
    config_option: configOption,
    config_value: configValue,
    exception_id: isSourceModifierSet ? Number(sourceModifier) : 0,
  } as EfsMelcoEfsModelsMappingOutputAttribute;
};

export const mergeAttributes = (
  outputs: EfsMelcoEfsModelsMappingOutput[] | null | undefined,
  attribute: EfsMelcoEfsModelsMappingOutputAttribute | undefined
) => {
  if (!outputs || !attribute || !outputs[0]) {
    return;
  }

  outputs[0].elements ||= [];

  if (outputs[0].elements.length <= 0) {
    outputs[0].elements.push({ attributes: [] });
  }

  const attributeByType = outputs[0].elements[0].attributes!.find(
    (a) => a.type === attribute.type
  );

  if (attributeByType) {
    Object.assign(attributeByType, attribute);
  } else {
    outputs[0].elements[0].attributes!.push(attribute);
  }
};

const getDataMappingAttribute = (
  dataMapping: EfsMelcoEfsModelsMapping,
  outputType: string
) => {
  const { outputs } = dataMapping;

  const defaultElement = ((outputs ?? [])[0].elements ?? [])[0];

  if (!defaultElement) {
    return;
  }

  const attribute = (defaultElement.attributes ?? []).find(
    (a) => a.type === outputType
  );

  if (!attribute) {
    return;
  }

  const { format_detail_id, config_value, exception_id, value } = attribute;

  const mapping: any = {
    dataSource: String(format_detail_id) ?? "",
    sourceModifier: String(exception_id) ?? "",
    value: String(value) ?? "",
  };

  if (outputType === "Color") {
    mapping.colorCollection = config_value ?? "";
  } else if (outputType === "Font") {
    mapping.fontCollection = config_value ?? "";
  }

  return mapping;
};

export const dataMappingToInitialValues = (
  dataMapping: EfsMelcoEfsModelsMapping
) => {
  const initialValues: DataMappingFormValueType = {
    ...dataMapping,
    _color: getDataMappingAttribute(dataMapping, "Color"),
    _text: getDataMappingAttribute(dataMapping, "Text"),
    _font: getDataMappingAttribute(dataMapping, "Font"),
    _display: getDataMappingAttribute(dataMapping, "Display"),
  };

  return initialValues;
};

export const newDataMapping = (inputFormatId: string) => {
  const dataMapping: EfsMelcoEfsModelsMapping = {
    format_id: inputFormatId,
    name: "",
    global: true,
    config_type: "none",
    outputs: [
      {
        name: "DEFAULT",
        elements: [],
      },
    ],
  };

  return dataMapping;
};
